import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { membersService } from '../api/members.service';
import { MEMBERS_KEYS } from './queryKeys';

/**
 * Assigns or unassigns a member to an area.
 * Calls PUT /api/tenants/members/{memberId}/area.
 *
 * @remarks
 * On success, invalidates `MEMBERS_KEYS.byOrg` so the members list reflects
 * the updated `areaId`. Toast feedback is handled at the call site.
 */
export function useAssignMemberArea() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: ({ memberId, areaId }: { memberId: string; areaId: string | null }) =>
      membersService.assignMemberArea(memberId, areaId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MEMBERS_KEYS.byOrg(orgId) });
    },
  });
}
